import React from "react";
import ReactDOM from "react-dom/client";
import App from "./app";
import "./theme/tokens.css"; // CSS variables
import { initTheme } from './theme';
import { Provider } from "react-redux";
import store from "./store";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ScrollToTop from "./components/Layout/scrollToTop";
const root = ReactDOM.createRoot(document.getElementById("root"));
initTheme();

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
      <ScrollToTop />
        <Routes>
          <Route path="/*" element={<App />} />
        </Routes>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);
